export default "__VITE_ASSET__BjvEO4na__"